import React from 'react';

function UserRow({ user, onEdit, onDelete }) {
  const queueBadges = user.queues?.map(q => (
    <span key={q} className={`badge badge-${q}`}>
      {q}
    </span>
  ));

  return (
    <tr className={!user.active ? 'inactive' : ''}>
      <td>
        <div className="user-cell">
          <strong>{user.user_id}</strong>
          <small>{user.jira_username}</small>
        </div>
      </td>
      <td>
        <span className="badge badge-tz">{user.timezone}</span>
      </td>
      <td>{user.country}</td>
      <td>
        <div className="queue-badges">{queueBadges}</div>
      </td>
      <td>
        {user.capped_user ? (
          <span className="badge badge-warning">Capped (5)</span>
        ) : (
          <span className="badge badge-success">No Cap</span>
        )}
      </td>
      <td>
        {user.active ? (
          <span className="status-active">Active</span>
        ) : (
          <span className="status-inactive">Inactive</span>
        )}
      </td>
      <td>
        <div className="action-buttons">
          <button
            onClick={() => onEdit(user)}
            className="btn-edit"
            title="Edit user"
          >
            Edit
          </button>
          <button
            onClick={() => onDelete(user.user_id)}
            className="btn-delete"
            title="Deactivate user"
            disabled={!user.active}
          >
            Delete
          </button>
        </div>
      </td>
    </tr>
  );
}

export default UserRow;
